import { Divider, Badge, IconButton, Tooltip } from "@mui/material";
import CollapsibleContainer from "../../../common/containers/CollapsibleContainer";
import TypeFilterInput from "./TypeFilterInput";
import TextFilterInput from "./TextFilterInput";
import ClearFilterButton from "./ClearFilterButton";
import { FilterAlt } from "@mui/icons-material";
import { areSavedAlbumsFiltersEmpty } from "../../../../reducers/albumListState";
import { useSelector } from "react-redux";
import { useShowingContext } from "../../../../hooks/others/useShowingContext";
import { useViewport } from "../../../../hooks/others/useViewport";
import { DETAILED_BREAKPOINTS, FILTER_ROW_XS_INPUT_LAYOUT_CLASS, FILTER_ROW_XS_MAIN_LAYOUT_CLASS } from "../../../../utils/constants/viewConstants";
import { isShowingQueueDisplayer } from "../../../../reducers/randomMode";

const AlbumListFilterRow = () => {
    const randomQueueDisplayerVisible = useSelector(isShowingQueueDisplayer);
    const noFilters = useSelector(areSavedAlbumsFiltersEmpty);
    const {showing: showingFilters} = useShowingContext();

    const showThis = useViewport({
        xs: false,
        sm: !randomQueueDisplayerVisible,
        md: true
    })

    if(!showThis) return;

    return (
        <>
            <Divider orientation="vertical" flexItem />

            <CollapsibleContainer expanded={showingFilters} orientation="horizontal">
                <div className="d-flex flex-row ai-center gap-0_5">
                    <TypeFilterInput />
                    <TextFilterInput />
                    {
                        noFilters &&
                        <ClearFilterButton />
                    }
                </div>
            </CollapsibleContainer>

            {
                !noFilters &&
                <ClearFilterButton />
            }
        </>
    )
}

export const AlbumListFilterRowXS = () => {
    const randomQueueDisplayerVisible = useSelector(isShowingQueueDisplayer);
    const {showing: showingFilters} = useShowingContext();

    const showThis = useViewport({
        xs: true,
        sm: randomQueueDisplayerVisible,
        md: false
    });

    const layoutClass = useViewport(FILTER_ROW_XS_MAIN_LAYOUT_CLASS, DETAILED_BREAKPOINTS)
    const inputLayoutClass = useViewport(FILTER_ROW_XS_INPUT_LAYOUT_CLASS, DETAILED_BREAKPOINTS);

    if(!showThis) return;

    return (
        <CollapsibleContainer expanded={showingFilters}>
            <div className="d-flex flex-column gap-0_5 mb-0_5">
                <Divider />
                <div className={`d-flex flex-row ${layoutClass} gap-0_5`}>
                    <div className={`d-flex ${inputLayoutClass} gap-0_5`}>
                        <TypeFilterInput />
                        <TextFilterInput />
                    </div>
                    <ClearFilterButton />
                </div>
            </div>
        </CollapsibleContainer>
    )
}

const AlbumListFilters = () => {
    const noFilters = useSelector(areSavedAlbumsFiltersEmpty);
    const {showing: showingFilters, setShowing: setShowingFilters} = useShowingContext();

    const onClickFilter = () => {
        setShowingFilters(sF => !sF);
    }

    return (
        <div className="d-flex flex-row ai-center gap-0_5">
            <Tooltip title={(!showingFilters && !noFilters) && "Some filters are applied"}>
                <span>
                    <IconButton color={(showingFilters || !noFilters) ? "primary" : "default"} onClick={onClickFilter}>
                        <div className="d-flex">
                            <Badge color="error" variant="dot" invisible={noFilters || showingFilters}>
                                <FilterAlt />
                            </Badge>
                        </div>
                    </IconButton>
                </span>
            </Tooltip>

            <AlbumListFilterRow showingFilters={showingFilters} noFilters={noFilters} />

        </div>
    )
}

export default AlbumListFilters;